import { useEffect, useRef, useState } from 'react';

// NHẮC TẢI LẠI KHI CÓ BẢN DEPLOY MỚI. Nguyên lý: bundle Vite có HASH trong tên file
// (/assets/index-<hash>.js) — so tên bundle TAB NÀY đang chạy với tên trong index.html
// MỚI NHẤT trên server (fetch no-store). Lệch hash = server vừa deploy bản mới.
// Giải bệnh kinh niên: deploy xong nhưng tab mở sẵn vẫn chạy bản cũ cả ngày (thiếu tính
// năng, dính bug đã sửa) mà người dùng không hề biết — phải nhờ từng người Ctrl+Shift+R.
// Không cần backend: chỉ đọc index.html tĩnh (~1KB) do nginx phục vụ.
const CHECK_MS = 5 * 60 * 1000; // kiểm tra định kỳ 5 phút
const MIN_GAP_MS = 60 * 1000; // quay lại tab -> kiểm tra ngay, nhưng không dày hơn 60s
const SNOOZE_MS = 30 * 60 * 1000; // "Để sau" -> 30 phút sau nhắc lại (bản mới vẫn đang chờ)

const bundleOf = (html) => {
  const m = String(html || '').match(/index-[\w-]+\.js/);
  return m ? m[0] : '';
};

export default function UpdateBanner() {
  const [stale, setStale] = useState(false);
  const [snoozed, setSnoozed] = useState(false);
  const lastCheckRef = useRef(0);

  useEffect(() => {
    if (import.meta.env.DEV) return; // dev server không có bundle hash -> bỏ qua
    const mine = bundleOf(document.querySelector('script[src*="/assets/index-"]')?.getAttribute('src'));
    if (!mine) return;
    let alive = true;
    const check = async () => {
      const now = Date.now();
      if (now - lastCheckRef.current < MIN_GAP_MS) return;
      lastCheckRef.current = now;
      try {
        // no-store + query bust: phải là index.html TƯƠI từ server, không lấy bản cache.
        const html = await fetch(`/?_ftv=${now}`, { cache: 'no-store' }).then((r) => r.text());
        const latest = bundleOf(html);
        if (alive && latest && latest !== mine) setStale(true);
      } catch { /* mất mạng tạm thời -> lượt sau thử lại */ }
    };
    const iv = setInterval(check, CHECK_MS);
    const onWake = () => { if (!document.hidden) check(); }; // quay lại tab là lúc dễ dính bản cũ nhất
    document.addEventListener('visibilitychange', onWake);
    window.addEventListener('focus', onWake);
    const t0 = setTimeout(check, 15000); // lượt đầu sau 15s, tránh chen lúc app đang khởi động
    return () => {
      alive = false;
      clearInterval(iv);
      clearTimeout(t0);
      document.removeEventListener('visibilitychange', onWake);
      window.removeEventListener('focus', onWake);
    };
  }, []);

  const snooze = () => {
    setSnoozed(true);
    setTimeout(() => setSnoozed(false), SNOOZE_MS);
  };

  if (!stale || snoozed) return null;
  return (
    <div className="ft-update-pop" role="alert">
      <span className="ft-update-txt">🚀 FunnyTask vừa có <b>bản cập nhật mới</b> — tải lại để dùng bản mới nhất.</span>
      <button className="btn sm" onClick={() => window.location.reload()}>⟳ Tải lại ngay</button>
      <button className="btn sm ghost" onClick={snooze}>Để sau</button>
    </div>
  );
}
